import { NICmsContentField } from '@icms/core/content';
import { NBuilderConfig } from '../../common/builder.config';
export namespace NKitGeneralSetup {
    export interface IGeneralSetupData {
        useToyAttr: boolean;
        firstStepTitle: string;
        firstStepOptions: ISetupElementData[];
        ponyShift: number;
        ponyShiftWithRider?: number;
    }
    export interface ISetupElementData extends NBuilderConfig.ISetupElementData {
        productId: number;
    }

    const tab = 'Builder General Setup';
    export const setupElementFields = [
        <NICmsContentField.IField>{
            tab: tab,
            key: 'name',
            type: NICmsContentField.EFieldType.text,
            title: 'Name',
            description: 'Name of option have to be uniq cause it is use as identifier of option',
            required: true
        },
        <NICmsContentField.IField>{
            tab: tab,
            key: 'image',
            title: 'Image',
            type: NICmsContentField.EFieldType.image,
            required: true,
            default: '/cms/media/default.png'
        },

        <NICmsContentField.IField>{
            tab: tab,
            key: 'preselect',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Preselect',
            default: false
        },
        <NICmsContentField.IField>{
            tab: tab,
            key: 'imageConfiguration',
            title: 'Image product configuration',
            type: NICmsContentField.EFieldType.image,
            required: true,
            default: '/cms/media/default.png'
        },
        <NICmsContentField.IField>{
            tab: tab,
            key: 'alternativeImageConfiguration',
            title: 'Alternative image',
            type: NICmsContentField.EFieldType.image,
            description: 'This image will be displayed instead image configuration when product form specific section is selected',
            default: '/cms/media/default.png'
        },
        <NICmsContentField.IRelationField>{
            tab: tab,
            key: 'productId',
            type: NICmsContentField.EFieldType.relation,
            title: 'Product',
            options: {
                multiple: false,
                title: 'Product',
                type: 'product',
                filter: model => model.isSimple
            }
        }
    ];

    export const generalSetupFields = [
        <NICmsContentField.INumberField>{
            tab: tab,
            key: 'typeData.ponyShift',
            type: NICmsContentField.EFieldType.number,
            title: 'Base position',
            description: 'Base gallery position horizontally (from -40 to 40)',
            required: true,
            min: -40,
            max: 40,
            default: 0
        },
        <NICmsContentField.INumberField>{
            tab: tab,
            key: 'typeData.ponyShiftWithRider',
            type: NICmsContentField.EFieldType.number,
            title: 'Pony image position with rider',
            description: 'Shift pony image horizontally (from -40 to 40) applied when rider image is visible',
            required: true,
            min: -40,
            max: 40,
            default: 0
        },
        {
            type: NICmsContentField.EFieldType.label,
            tab: tab,
            key: 'typeData.configuration-step',
            title: 'Configure step'
        },
        <NICmsContentField.IToggleField>{
            tab: tab,
            key: 'typeData.useToyAttr',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Use eligible toy attr',
            labels: { true: 'Use `toy_eligible_builder` attr', false: 'Use `eligible_builder` attr' },
            default: true
        },
        <NICmsContentField.IField>{
            tab: tab,
            key: 'typeData.firstStepTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'First step title',
            default: 'Select your pony',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            tab: tab,
            key: 'typeData.firstStepOptions',
            type: NICmsContentField.EFieldType.repeater,
            title: 'First step options',
            itemName: 'Option',
            itemNameField: 'name',
            required: true,
            defaultSize: 3,
            fields: setupElementFields
        }
    ];
}
